import store from '@/store'

export const PERM_TREE = [
  { key: 'dashboard', name: '经营驾驶舱', perms: [] },
  { key: 'customer', name: '客户管理', perms: ['customer:list', 'customer:add', 'customer:edit', 'customer:delete', 'customer:follow', 'customer:export'] },
  { key: 'opportunity', name: '商机管理', perms: ['opportunity:list', 'opportunity:add', 'opportunity:edit', 'opportunity:win'] },
  { key: 'quote', name: '销售报价', perms: ['quote:list', 'quote:add', 'quote:edit', 'quote:delete', 'quote:simulate', 'quote:submit', 'quote:approve', 'quote:revise', 'quote:to_contract'] },
  { key: 'contract', name: '合同管理', perms: ['contract:list', 'contract:add', 'contract:edit', 'contract:delete'] },
  { key: 'agent', name: '代理商管理', perms: ['agent:list', 'agent:add', 'agent:rebate'] },
  { key: 'sales-target', name: '销售目标', perms: ['target:list', 'target:set'] },
  { key: 'sales-perf', name: '销售业绩提成', perms: ['perf:list', 'perf:export'] },
  { key: 'material', name: '销售项目', perms: ['material:list', 'material:add', 'material:edit', 'material:package'] },
  { key: 'inventory', name: '库存管理', perms: ['inventory:list', 'inventory:in', 'inventory:out'] },
  { key: 'project', name: '项目管理', perms: ['project:list', 'project:add', 'project:edit', 'project:follow'] },
  { key: 'shipment', name: '发货管理', perms: ['shipment:list', 'shipment:add'] },
  { key: 'delivery', name: '交付管理', perms: ['delivery:list', 'delivery:add'] },
  { key: 'invoice', name: '开票管理', perms: ['invoice:list', 'invoice:add'] },
  { key: 'receivable', name: '应收管理', perms: ['receivable:list', 'receivable:writeoff'] },
  { key: 'receipt', name: '回款管理', perms: ['receipt:list', 'receipt:add'] },
  { key: 'expense', name: '支出录入', perms: ['expense:list', 'expense:add', 'expense:delete'] },
  { key: 'payable', name: '应付管理', perms: ['payable:list', 'payable:pay'] },
  { key: 'pnl', name: '公司利润表', perms: ['pnl:view', 'pnl:export'] },
  { key: 'cashflow', name: '现金流量表', perms: ['cashflow:view'] },
  { key: 'profit-project', name: '项目利润分析', perms: ['profit_project:view'] },
  { key: 'profit-customer', name: '客户利润分析', perms: ['profit_customer:view'] },
  { key: 'profit-agent', name: '代理商利润分析', perms: ['profit_agent:view'] },
  { key: 'sales-item-analysis', name: '销售项目分析', perms: ['sales_item:view', 'sales_item:export'] },
  { key: 'sales-region', name: '区域行业分析', perms: ['region:view'] },
  { key: 'efficiency', name: '人效分析', perms: ['efficiency:view'] },
  { key: 'report', name: '年度营收报表', perms: ['report:view', 'report:export'] },
  { key: 'forecast', name: '经营预测', perms: ['forecast:view'] },
  { key: 'service-ticket', name: '售后与服务', perms: ['service:list', 'service:add', 'service:edit', 'service:handle', 'service:delete'] },
  { key: 'reminder', name: '提醒中心', perms: ['reminder:list', 'reminder:handle'] },
  { key: 'rules', name: '规则与分摊', perms: ['rules:view', 'rules:edit'] },
  { key: 'role', name: '角色管理', perms: ['role:list', 'role:add', 'role:edit', 'role:delete'] },
  { key: 'role-permission', name: '权限分配', perms: ['roleperm:view', 'roleperm:assign'] },
  { key: 'permission', name: '字段权限', perms: ['fieldperm:view', 'fieldperm:edit'] }
]

/** 将 sys_permission 扁平列表组装为权限树（菜单 + 按钮） */
export function buildPermTreeFromDb(records) {
  if (!records || !records.length) return []
  const menus = records
    .filter((p) => p.permType === 'menu' && (!p.parentId || p.parentId === 0))
    .sort((a, b) => (a.sort || 0) - (b.sort || 0))
  const buttonsByMenu = {}
  records
    .filter((p) => p.permType === 'button')
    .forEach((p) => {
      const pid = p.parentId
      if (!buttonsByMenu[pid]) buttonsByMenu[pid] = []
      buttonsByMenu[pid].push(p)
    })
  Object.keys(buttonsByMenu).forEach((pid) => {
    buttonsByMenu[pid].sort((a, b) => (a.sort || 0) - (b.sort || 0))
  })
  return menus.map((m) => ({
    key: m.resource || String(m.permCode || '').replace(/^menu:/, ''),
    name: m.name,
    menuCode: m.permCode,
    perms: (buttonsByMenu[m.id] || []).map((b) => ({ code: b.permCode, name: b.name }))
  }))
}

export const FIELD_PERM_DEFAULT = {
  sales: {
    gross_profit: 'hidden',
    net_profit: 'hidden',
    margin: 'hidden',
    cost: 'hidden'
  },
  ops: {
    contact_phone: 'masked',
    gross_profit: 'hidden',
    net_profit: 'hidden',
    cost: 'hidden'
  },
  finance: {
    contact_phone: 'readonly'
  },
  admin: {}
}

function defaultRolePerms() {
  const all = []
  PERM_TREE.forEach((m) => {
    all.push(`menu:${m.key}`)
    m.perms.forEach((p) => all.push(p))
  })
  return {
    admin: all,
    finance: [
      'menu:dashboard', 'menu:receivable', 'menu:receipt', 'menu:payable', 'menu:expense', 'menu:invoice',
      'menu:pnl', 'menu:cashflow', 'menu:profit-customer', 'menu:profit-project', 'menu:report',
      'receivable:list', 'receivable:writeoff', 'receipt:list', 'receipt:add', 'payable:list', 'payable:pay',
      'expense:list', 'invoice:list', 'invoice:add', 'pnl:view', 'pnl:export', 'cashflow:view',
      'profit_customer:view', 'profit_project:view', 'report:view', 'report:export'
    ],
    sales: [
      'menu:dashboard', 'menu:customer', 'menu:opportunity', 'menu:quote', 'menu:contract', 'menu:agent',
      'menu:sales-target', 'menu:sales-perf', 'menu:reminder',
      'customer:list', 'customer:add', 'customer:edit', 'customer:follow',
      'opportunity:list', 'opportunity:add', 'opportunity:edit', 'opportunity:win',
      'quote:list', 'quote:add', 'quote:simulate', 'quote:to_contract',
      'contract:list', 'contract:add', 'agent:list', 'target:list', 'perf:list', 'reminder:list'
    ],
    ops: [
      'menu:dashboard', 'menu:customer', 'menu:project', 'menu:material', 'menu:inventory',
      'menu:shipment', 'menu:delivery', 'menu:reminder',
      'customer:list', 'customer:follow', 'project:list', 'project:edit', 'project:follow',
      'material:list', 'inventory:list', 'inventory:in', 'inventory:out',
      'shipment:list', 'shipment:add', 'delivery:list', 'delivery:add', 'reminder:list', 'reminder:handle'
    ]
  }
}

export function getDefaultRolePerms() {
  return defaultRolePerms()
}

export function getRolePerms() {
  try {
    const s = localStorage.getItem('xp_roleperms')
    if (s) return JSON.parse(s)
  } catch (e) { /* ignore */ }
  return defaultRolePerms()
}

export function getDefaultFieldPerm() {
  return JSON.parse(JSON.stringify(FIELD_PERM_DEFAULT))
}

export function getFieldPerm() {
  try {
    const s = localStorage.getItem('xp_fieldperm')
    if (s) return JSON.parse(s)
  } catch (e) { /* ignore */ }
  return JSON.parse(JSON.stringify(FIELD_PERM_DEFAULT))
}

export function saveFieldPerm(cfg) {
  try { localStorage.setItem('xp_fieldperm', JSON.stringify(cfg)) } catch (e) { /* ignore */ }
}

export function resetFieldPerm() {
  try { localStorage.removeItem('xp_fieldperm') } catch (e) { /* ignore */ }
}

export function saveRolePerms(cfg) {
  try { localStorage.setItem('xp_roleperms', JSON.stringify(cfg)) } catch (e) { /* ignore */ }
}

export function resetRolePerms() {
  try { localStorage.removeItem('xp_roleperms') } catch (e) { /* ignore */ }
}

export function hasPerm(code) {
  const user = store.state.user || {}
  if (user.isSuper) return true
  const list = user.permCodes || []
  return list.indexOf(code) >= 0
}

export function hasMenu(key) {
  const user = store.state.user || {}
  if (user.isSuper) return true
  const list = user.permCodes || []
  return list.indexOf(`menu:${key}`) >= 0
}

function maskValue(text) {
  const s = (text || '').trim()
  if (!s) return s
  const digits = s.replace(/\D/g, '')
  if (digits.length === 11) return `${digits.slice(0, 3)}****${digits.slice(7)}`
  if (s.length <= 2) return '**'
  return `${s.slice(0, 1)}****${s.slice(-1)}`
}

export function getFieldRule(field) {
  const user = store.state.user || {}
  const role = user.roleCode || 'admin'
  const rules = getFieldPerm()[role] || {}
  return rules[field] || null
}

export function applyFieldDisplay(field, value) {
  const rule = getFieldRule(field)
  if (rule === 'hidden') return { hidden: true, value: '' }
  if (rule === 'masked') return { hidden: false, value: maskValue(String(value)) }
  return { hidden: false, value, readonly: rule === 'readonly' }
}

export function applyFieldPerm(vm) {
  if (!vm || !vm.$el) return
  vm.$el.querySelectorAll('[data-field]').forEach((el) => {
    const field = el.getAttribute('data-field')
    const rule = getFieldRule(field)
    el.classList.remove('perm-hidden', 'perm-masked')
    if (rule === 'hidden') {
      el.classList.add('perm-hidden')
    } else if (rule === 'masked' && el.dataset.permOrig == null) {
      el.dataset.permOrig = el.textContent
      el.textContent = maskValue(el.textContent)
      el.classList.add('perm-masked')
    }
    const inputs = el.querySelectorAll('input, select, textarea')
    inputs.forEach((i) => {
      if (rule === 'readonly') {
        i.setAttribute('readonly', 'readonly')
        i.setAttribute('disabled', 'disabled')
      } else {
        i.removeAttribute('readonly')
        i.removeAttribute('disabled')
      }
    })
  })
}
